import { render, staticRenderFns } from "./PermissionsListFilter.vue?vue&type=template&id=587cec4c&"
import script from "./PermissionsListFilter.vue?vue&type=script&lang=js&"
export * from "./PermissionsListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports